export const COOKIE_CONSENT_KEY = "cookieConsent";
export const COOKIE_CONSENT_VALUES = {
	DENY: "deny",
	ACCEPT: "accept",
};
